/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FlagDetailsContainer_settings = {
    readonly integrations: {
        readonly perspective: {
            readonly threshold: number | null;
        };
    };
    readonly " $refType": "FlagDetailsContainer_settings";
};
export type FlagDetailsContainer_settings$data = FlagDetailsContainer_settings;
export type FlagDetailsContainer_settings$key = {
    readonly " $data"?: FlagDetailsContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"FlagDetailsContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FlagDetailsContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ExternalIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "PerspectiveExternalIntegration",
                    "kind": "LinkedField",
                    "name": "perspective",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "threshold",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '6560692c88ed8b225d5000ef8804b957';
export default node;
